import { render, staticRenderFns } from "./LecturesView.vue?vue&type=template&id=333e8342"
import script from "./LecturesView.vue?vue&type=script&lang=js"
export * from "./LecturesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports